import { create } from 'zustand';
import { SymptomQuestionResponse } from 'services/symptom-checker/type';

type SymptomStore = {
  questionData: SymptomQuestionResponse | undefined;
};

type SymptomActions = {
  setQuestionData: (data: SymptomQuestionResponse | undefined) => void;
};

const initialState: SymptomStore = {
  questionData: undefined,
};

export const useSymptomStore = create<SymptomStore & SymptomActions>((set) => ({
  ...initialState,
  setQuestionData: (data) => set({ questionData: data }),
}));
